import { FormInput, Grid } from '@kirz/mui-admin';
import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  const validate = (val: string): boolean => {
    // Remove spaces and check if it starts with BE and has exactly 16 characters
    const cleanVal = val.replace(/\s/g, '');
    if (!cleanVal.startsWith('BE') || cleanVal.length !== 16) {
      return false;
    }

    // Check if all remaining characters after BE are numbers
    return /^\d+$/.test(cleanVal.slice(2));
  };

  return (
    <StepWrapper
      name="Bankrekening waarop de eventuele teruggave gestort kan worden"
      description="Typ hieronder het IBAN nummer van de rekening"
      maxWidth={1000}
    >
      <Grid container spacing={4}>
        <FormInput
          name="iban"
          label="IBAN nummer"
          placeholder="BE 71 0961 2345 6769"
          required
          fullWidth
          rules={{
            validate: (val: string) => {
              if (!validate(val)) {
                return 'Het IBAN nummer moet beginnen met BE en moet 16 karakters lang zijn';
              }
              return true;
            },
          }}
          InputProps={{
            inputComponent: MaskedIbanInput as any,
            inputProps: {
              onAccept: (val: string) => {},
            },
          }}
        />
      </Grid>
    </StepWrapper>
  );
}

const MaskedIbanInput = forwardRef<HTMLElement, any>(function MaskedIbanInput(
  props,
  ref,
) {
  const { onAccept, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="BE 00 0000 0000 0000"
      definitions={{
        '0': /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(val: string) => {
        other.onChange({
          target: {
            name: other.name,
            value: val,
          },
        });
      }}
      overwrite
    />
  );
});
